// frontend/src/components/CardAlertImpact.js
import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';
import Skeleton from '@mui/material/Skeleton';

export default function CardAlertImpact({ content, loading }) {
  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <WarningAmberRounded fontSize="small" sx={{ mr: 1, color: 'warning.main' }} />
          <Typography sx={{ fontWeight: 600 }}>
            Potential Impacts
          </Typography>
        </Box>
        {loading ? (
          <>
            <Skeleton variant="text" sx={{ fontSize: '0.875rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '0.875rem' }} />
          </>
        ) : (
          <Typography variant="body2" sx={{ color: 'text.secondary', whiteSpace: 'pre-line' }}>
            {content || 'No specific impacts identified.'}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}